import React, { useState, useEffect } from 'react';

const SouthKoreaPopup = ({ isVisible, onClose }) => {
	const [countdown, setCountdown] = useState(10);
	const [isCountdownActive, setIsCountdownActive] = useState(false);

	useEffect(() => {
		if (isVisible) {
			setCountdown(10);
			setIsCountdownActive(true);

			const timer = setInterval(() => {
				setCountdown((prev) => {
					if (prev <= 1) {
						clearInterval(timer);
						// Auto redirect to South Korea site
						handleVisitSouthKorea();
						return 0;
					}
					return prev - 1;
				});
			}, 1000);

			return () => clearInterval(timer);
		}
	}, [isVisible]);

	const handleVisitSouthKorea = () => {
		let queryParams = window.location.search;
		queryParams += (queryParams ? '&' : '?') + 'aud_p=redirected';

		const koreaUrl = `https://hear.com/kr${queryParams}`;
		window.location.href = koreaUrl;
	};

	const handleContinueOnSite = () => {
		onClose();
	};

	if (!isVisible) return null;

	const handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			handleContinueOnSite();
		}
	};

	return (
		<div
			className="c-country-popup-overlay"
			onKeyDown={handleKeyDown}
			tabIndex={0}
			role="dialog"
			aria-label="Country selection popup overlay"
		>
			<div
				className="c-country-popup c-south-korea-popup c-korea-popup-new"
				onClick={(e) => e.stopPropagation()}
				onKeyDown={(e) => e.stopPropagation()}
				tabIndex={0}
				role="dialog"
				aria-label="Country selection popup"
				style={{
					position: 'relative',
					overflow: 'visible'
				}}
			>
				<button
					className="c-popup-close-btn c-popup-close-btn__korea"
					onClick={handleContinueOnSite}
					aria-label="Close popup"
				>
					<img
						src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1749587569/assets/na/seo-website/close-button.svg"
						alt="Close"
					/>
				</button>

				<div className="c-popup-content c-popup-content__korea">
					<div className="c-popup-header">
						<div className="o-row-1 o-row-3-d">
							<p className="c-popup-header__title c-popup-header__title__korea u-mobile-hidden-korea">
								<span className="u-color-brand">히어닷컴</span>을 찾아주셔서 감사합니다!
							</p>
							<p className="c-popup-header__title c-popup-header__title__korea u-desktop-hidden-korea">
								<span className="u-color-brand">히어닷컴</span>을<br /> 찾아주셔서 감사합니다!
							</p>
						</div>
						<div className="o-row-3 u-desktop-hidden-korea">
							<p className="c-popup-header__subtitle-mobile">(글로벌 영문 홈페이지 접속 중)</p>
						</div>
						<div className="o-row-4 u-desktop-hidden-korea">
							<p className="c-popup-header__subtitle c-popup-header__subtitle__korea">한국어 홈페이지에서</p>
							<p className="c-popup-header__subtitle c-popup-header__subtitle__korea">히어닷컴을 더 알아보세요.</p>
						</div>
						<div className="o-row-4 u-mobile-hidden-korea">
							<p className="c-popup-header__subtitle" style={{ fontWeight: '400' }}>
								글로벌 영문 홈페이지에 접속하셨습니다.
							</p>
							<p className="c-popup-header__subtitle c-popup-header__subtitle__korea">
								한국어 홈페이지에서 히어닷컴을 더 알아보세요.
							</p>
						</div>
					</div>
					<div className="o-row-4">
						<div className="c-popup-actions">
							<button className="c-btn-primary-korea" onClick={handleVisitSouthKorea}>
								<img
									className="c-btn-primary-korea__flag"
									src="https://res.cloudinary.com/dhqvlsb3l/image/upload/f_auto,fl_lossy,q_auto:eco,w_auto,dpr_auto/assets/na/seo-website/south-korea-flag.png"
									alt="South Korea Flag"
								/>
								한국어 홈페이지 보기
								<img
									className="c-btn-primary-korea__arrow"
									src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/arrow-right.svg"
									alt=""
								/>
							</button>
							<button className="c-btn-secondary-korea" onClick={handleContinueOnSite}>
								<img
									src="https://res.cloudinary.com/dhqvlsb3l/image/upload/v1/assets/na/seo-website/globe.svg"
									alt=""
								/>
								영문으로 계속 보기
							</button>
						</div>
					</div>

					{isCountdownActive && (
						<div className="c-countdown-banner-korea">{countdown}초 후 한국 홈페이지로 이동합니다.</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default SouthKoreaPopup;
